import React from 'react'
import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  makeStyles
} from '@material-ui/core'
import { ChevronLeft, ChevronRight } from '@material-ui/icons'
import { AgentOption } from '../types'
import { bogotaPeriod } from '../utils'

const useStyles = makeStyles(theme => ({
  toolbar: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: '1px solid #e3e6ea'
  },
  monthControl: { display: 'flex', alignItems: 'center', background: '#fff', borderRadius: 6, padding: '4px 6px' },
  monthInput: { width: 180 },
  agentSelect: { minWidth: 260 },
  spacer: { flexGrow: 1 }
}))

const moveMonth = (period: string, amount: number) => {
  const [year, month] = period.split('-').map(Number)
  const next = new Date(Date.UTC(year, month - 1 + amount, 1))
  return `${next.getUTCFullYear()}-${String(next.getUTCMonth() + 1).padStart(2, '0')}`
}

interface Props {
  manager: boolean
  agents: AgentOption[]
  agentId: string
  period: string
  minPeriod: string
  onAgentChange: (agentId: string) => void
  onPeriodChange: (period: string) => void
}

const AgentCommissionFilters: React.FC<Props> = ({
  manager,
  agents,
  agentId,
  period,
  minPeriod,
  onAgentChange,
  onPeriodChange
}) => {
  const classes = useStyles()
  const maxPeriod = bogotaPeriod()
  return (
    <Box className={classes.toolbar}>
      <Box className={classes.monthControl}>
        <Tooltip title="Mes anterior">
          <span>
            <IconButton
              aria-label="Mes anterior"
              disabled={Boolean(minPeriod && period <= minPeriod)}
              onClick={() => onPeriodChange(moveMonth(period, -1))}
            >
              <ChevronLeft />
            </IconButton>
          </span>
        </Tooltip>
        <TextField
          className={classes.monthInput}
          type="month"
          label="Período"
          value={period}
          inputProps={{ min: minPeriod || undefined, max: maxPeriod }}
          InputLabelProps={{ shrink: true }}
          onChange={event => onPeriodChange(event.target.value)}
        />
        <Tooltip title="Mes siguiente">
          <span>
            <IconButton
              aria-label="Mes siguiente"
              disabled={period >= maxPeriod}
              onClick={() => onPeriodChange(moveMonth(period, 1))}
            >
              <ChevronRight />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
      {manager ? (
        <FormControl className={classes.agentSelect}>
          <InputLabel>Agente</InputLabel>
          <Select value={agentId} onChange={event => onAgentChange(event.target.value as string)}>
            {agents.map(agent => (
              <MenuItem key={agent._id} value={agent._id}>
                {agent.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : null}
      <Box className={classes.spacer} />
    </Box>
  )
}

export default AgentCommissionFilters
